import { createSlice } from '@reduxjs/toolkit';

const sessionSlice = createSlice({
  name: 'session',
  initialState: { country: null as string | null },
  reducers: {
    setCountry: (state, action) => {
      state.country = action.payload;
    },
    clearCountry: (state) => {
      state.country = null;
    }
  }
});

export const { setCountry, clearCountry } = sessionSlice.actions;
export default sessionSlice.reducer; 